class FormWithUtagLinkEvent {
    constructor(id, eventObj, callback) {
        this.formElement = document.getElementById(id);
        this.eventObj = eventObj;
        this.submitBtn = this.formElement.querySelector(".ip-form-btn-submit");
        this.loadingSpinner = document.createElement("img")
        if (callback && typeof callback === 'function') {
            this.callback = callback;
        }
        this.onInit();
    }

    utagEventFired = false

    onInit = () => {
        this.loadingSpinner.src = "/images/ajax-loader.gif";
        this.loadingSpinner.style.display = "none";
        this.submitBtn.insertAdjacentElement("afterend", this.loadingSpinner)
        this.formElement.addEventListener("submit", this.onSubmit, false)
    }

    onSubmit = (e) => {
        this.submitBtn.style.display = 'none';
        this.loadingSpinner.style.display = "block";

        if (!this.utagEventFired) {
            e.preventDefault();
            this.fireUtagFormSuccess();
        }
    }

    fireUtagFormSuccess = () => {
        const customerEmail = this.formElement.querySelector('input[type="email"]').value;

        utag.link({
            ...this.eventObj,
            "customer_email": customerEmail
        }, () => this.submitForm());
    }

    submitForm = () => {
        this.utagEventFired = true;

        // Standard Form Submission
        if (this.formElement.getAttribute("data-action")) {
            this.formElement.action = this.formElement.getAttribute("data-action");
            this.formElement.submit();
        }
        // Ajax Form Submission
        else if (this.formElement.getAttribute("data-ajax-post")) {
            const apiUrl = this.formElement.getAttribute("data-ajax-post");
            const elements = Array.from(this.formElement.elements);
            let data = {};

            elements.forEach(element => {
                if (element.name && element.name !== '') {
                    data[element.name] = element.value;
                }
            })

            const options = {
                method: 'POST',
                body: JSON.stringify(data),
                headers: new Headers({
                    "Content-Type": "application/json"
                }),
                credentials: "same-origin"
            }
    
            fetch(apiUrl, options)
                .then(response => {
                    if (this.callback) {
                        this.callback(response);
                    }
                    this.submitBtn.style.display = 'block';
                    this.loadingSpinner.remove();
                })
                .catch(error => console.error(error.message))
        }
    }
}

class ProgressBarWithAction {
    constructor({selector, action, duration}) {
        this.progressBar = document.querySelector(selector);
        this.action = action;
        this.timeRemaining = this.duration =
            duration ||
            parseInt(this.progressBar.getAttribute("max")) ||
            5;
        this.init();
    }

    init = () => {
        const downloadTimer = setInterval(() => {
            if(this.timeRemaining <= 0){
                clearInterval(downloadTimer);
                this.action();
            }
            this.progressBar.value = this.duration - this.timeRemaining;
            this.timeRemaining -= 1;
        }, 1000);
    }
}
